enum TabPaths {
  Timeline = 'timeline',
  Metrics = 'metrics',
}

export default TabPaths;
